import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

// QR码动态加载组件
function QrCodeWrapper({ value, size }) {
  const [QRComp, setQRComp] = useState(null)
  useEffect(() => {
    let cancelled = false
    import('qrcode.react').then(m => {
      if (!cancelled) setQRComp(() => m.QRCodeSVG)
    })
    return () => { cancelled = true }
  }, [])
  if (!QRComp) return <div style={{width:size,height:size,display:'flex',alignItems:'center',justifyContent:'center',color:'#999',fontSize:13}}>加载中...</div>
  return <QRComp value={value} size={size} />
}

const CODE_TYPES = [
  { value: 'all', label: '全部' },
  { value: 'growth_video', label: '成长视频', color: '#1890ff' },
  { value: 'activity_review', label: '活动回顾', color: '#52c41a' },
  { value: 'coupon', label: '优惠券', color: '#fa8c16' },
  { value: 'course', label: '课程体验', color: '#722ed1' },
  { value: 'material', label: '学习素材', color: '#eb2f96' },
  { value: 'gift', label: '礼品', color: '#13c2c2' }
]

export default function ClaimCodes() {
  const [stats, setStats] = useState({})
  const [codes, setCodes] = useState([])
  const [type, setType] = useState('all')
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState({ open: false, type: 'create' })
  const [form, setForm] = useState({ type: 'growth_video', count: 1, child_id: '', title: '' })
  const [children, setChildren] = useState([])
  const [selectedCode, setSelectedCode] = useState(null)
  const [tab, setTab] = useState('list')

  useEffect(() => {
    loadStats()
    loadChildren()
  }, [])

  useEffect(() => {
    loadCodes()
  }, [type])

  const loadStats = async () => {
    try {
      const res = await fetch(`${API}/unified-codes`)
      const data = await res.json()
      if (data.success) setStats(data.data.stats || {})
    } catch (e) { console.error(e) }
  }

  const loadChildren = async () => {
    try {
      const res = await fetch(`${API}/children?pageSize=100`)
      const data = await res.json()
      if (data.success) setChildren(data.data || [])
    } catch (e) { console.error(e) }
  }

  const loadCodes = async () => {
    setLoading(true)
    try {
      const url = type === 'all' ? `${API}/unified-codes?type=growth_video` : `${API}/unified-codes?type=${type}`
      const res = await fetch(url)
      const data = await res.json()
      if (data.success) setCodes(data.data || [])
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const handleCreate = async () => {
    try {
      const res = await fetch(`${API}/unified-codes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
      const data = await res.json()
      if (data.success) {
        alert(`成功生成 ${data.data.count} 个领取码！`)
        setModal({ open: false })
        loadStats()
        loadCodes()
      }
    } catch (e) {
      alert('生成失败')
    }
  }

  const handleBatchForChild = async () => {
    if (!form.child_id) {
      alert('请选择孩子')
      return
    }
    try {
      const child = children.find(c => c.id === form.child_id)
      const res = await fetch(`${API}/unified-codes/batch-for-child`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          child_id: form.child_id,
          child_name: child?.name || form.child_id,
          type: form.type,
          videos: []
        })
      })
      const data = await res.json()
      if (data.success) {
        alert(`成功为 ${child?.name} 生成 ${data.data.count} 个领取码！`)
        setModal({ open: false })
        loadStats()
        loadCodes()
      }
    } catch (e) {
      alert('生成失败')
    }
  }

  const getStatusBadge = (status) => {
    const map = {
      unused: { bg: '#e6f7ff', color: '#1890ff', text: '未使用' },
      used: { bg: '#f6ffed', color: '#52c41a', text: '已使用' }
    }
    const s = map[status] || { bg: '#f5f5f5', color: '#999', text: status }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 12, background: s.bg, color: s.color }}>{s.text}</span>
  }

  const copyCode = (code) => {
    navigator.clipboard.writeText(code)
    alert('已复制：' + code)
  }

  const cardStyle = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎫 领取码管理</h2>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 24 }}>
        {Object.entries(stats).map(([key, val]) => {
          const typeInfo = CODE_TYPES.find(t => t.value === key)
          return (
            <div key={key} style={{ ...cardStyle, borderLeft: `4px solid ${typeInfo?.color || '#999'}` }}>
              <div style={{ fontSize: 12, color: '#999', marginBottom: 4 }}>{typeInfo?.label || key}</div>
              <div style={{ fontSize: 24, fontWeight: 600 }}>{val?.total || 0}</div>
              <div style={{ fontSize: 11, color: '#52c41a' }}>已用 {val?.used || 0}</div>
            </div>
          )
        })}
      </div>

      {/* 操作栏 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <select value={type} onChange={e => setType(e.target.value)} style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #ddd' }}>
          {CODE_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
        <button onClick={() => setModal({ open: true, type: 'create' })} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
          + 生成领取码
        </button>
        <button onClick={() => setModal({ open: true, type: 'batch' })} style={{ padding: '8px 16px', background: '#52c41a', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
          批量生成
        </button>
      </div>

      {/* 列表 */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>领取码</th>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>类型</th>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>关联孩子</th>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>关联内容</th>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>状态</th>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>有效期</th>
              <th style={{ padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {codes.map(code => (
              <tr key={code.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: 12 }}>
                  <span style={{ fontFamily: 'monospace', fontSize: 14, fontWeight: 600 }}>{code.code}</span>
                </td>
                <td style={{ padding: 12 }}>
                  {(() => {
                    const t = CODE_TYPES.find(x => x.value === code.code_type)
                    return <span style={{ color: t?.color }}>{t?.label || code.code_type}</span>
                  })()}
                </td>
                <td style={{ padding: 12 }}>{code.child_name || '-'}</td>
                <td style={{ padding: 12, maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' }}>{code.title || code.video_title || '-'}</td>
                <td style={{ padding: 12 }}>{getStatusBadge(code.status)}</td>
                <td style={{ padding: 12, fontSize: 12, color: '#999' }}>{code.expire_at ? new Date(code.expire_at).toLocaleDateString() : '-'}</td>
                <td style={{ padding: 12 }}>
                  <button onClick={() => copyCode(code.code)} style={{ padding: '4px 8px', background: '#f5f5f5', border: 'none', borderRadius: 4, cursor: 'pointer', marginRight: 4 }}>复制</button>
                  <button onClick={() => setSelectedCode(code)} style={{ padding: '4px 8px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>详情</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {codes.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无数据</div>}
      </div>

      {/* 创建模态框 */}
      {modal.open && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 24, width: 400, maxHeight: '80vh', overflow: 'auto' }}>
            <h3 style={{ marginBottom: 16 }}>{modal.type === 'batch' ? '批量生成领取码' : '生成领取码'}</h3>
            
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>类型</label>
              <select value={form.type} onChange={e => setForm({...form, type: e.target.value})} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ddd' }}>
                {CODE_TYPES.filter(t => t.value !== 'all').map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </div>

            {modal.type === 'batch' && (
              <>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>选择孩子</label>
                  <select value={form.child_id} onChange={e => setForm({...form, child_id: e.target.value})} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ddd' }}>
                    <option value="">请选择</option>
                    {children.map(c => <option key={c.id} value={c.id}>{c.name} ({c.parent_phone})</option>)}
                  </select>
                </div>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>标题</label>
                  <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ddd' }} placeholder="领取码标题" />
                </div>
              </>
            )}

            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button onClick={modal.type === 'batch' ? handleBatchForChild : handleCreate} style={{ flex: 1, padding: 10, background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>生成</button>
              <button onClick={() => setModal({ open: false })} style={{ flex: 1, padding: 10, background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
            </div>
          </div>
        </div>
      )}

      {/* 详情模态框 */}
      {selectedCode && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 24, width: 400 }}>
            <h3 style={{ marginBottom: 16 }}>领取码详情</h3>
            
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <QrCodeWrapper value={`https://api.shitonghui.cn/claim/${selectedCode.code}`} size={150} />
              <div style={{ marginTop: 8, fontFamily: 'monospace', fontSize: 18, fontWeight: 600 }}>{selectedCode.code}</div>
            </div>

            <div style={{ fontSize: 13, color: '#666' }}>
              <div style={{ marginBottom: 8 }}>类型：{CODE_TYPES.find(t => t.value === selectedCode.code_type)?.label}</div>
              <div style={{ marginBottom: 8 }}>关联孩子：{selectedCode.child_name || '-'}</div>
              <div style={{ marginBottom: 8 }}>关联内容：{selectedCode.title || selectedCode.video_title || '-'}</div>
              <div style={{ marginBottom: 8 }}>状态：{getStatusBadge(selectedCode.status)}</div>
              <div style={{ marginBottom: 8 }}>有效期至：{selectedCode.expire_at ? new Date(selectedCode.expire_at).toLocaleDateString() : '-'}</div>
              {selectedCode.user_phone && <div style={{ marginBottom: 8 }}>领取人：{selectedCode.user_phone}</div>}
              {selectedCode.claimed_at && <div>领取时间：{new Date(selectedCode.claimed_at).toLocaleString()}</div>}
            </div>

            <button onClick={() => setSelectedCode(null)} style={{ width: '100%', marginTop: 16, padding: 10, background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>关闭</button>
          </div>
        </div>
      )}
    </div>
  )
}
